import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-bone pt-24 pb-8 px-6 md:px-12 border-t border-ink/10" data-id="element-270">
      <div className="max-w-[1280px] mx-auto" data-id="element-271">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20" data-id="element-272">
          {/* Brand */}
          <div className="md:col-span-1" data-id="element-273">
            <Link to="/" className="flex items-center gap-3 mb-6" data-id="element-274">
              <img src="https://cdn.magicpatterns.com/uploads/6F22E2Ctxndm5LAy6tPVXu/pasted-image.png" alt="Zylus Homes" className="h-12 w-auto" data-id="element-275" />
              <div className="flex flex-col leading-tight" data-id="element-276">
                <span className="font-serif text-xl tracking-tight text-ink font-medium" data-id="element-277">
                  Zylus
                </span>
                <span className="text-[9px] font-bold tracking-[0.2em] uppercase text-gold-dark -mt-0.5" data-id="element-278">
                  Homes & Property
                </span>
              </div>
            </Link>
            <p className="text-ink/60 text-sm leading-relaxed mb-3" data-id="element-279">
              Building strong, sustainable, proactive and long-term
              relationships with both corporate and private clients.
            </p>
            <p className="text-[10px] font-bold tracking-[0.2em] uppercase text-gold-dark mb-8" data-id="element-280">
              A Subsidiary of Zylus Group
            </p>
          </div>

          {/* Links */}
          <div data-id="element-281">
            <h4 className="font-semibold text-ink mb-6" data-id="element-282">Properties</h4>
            <ul className="space-y-4 text-sm text-ink/60" data-id="element-283">
              <li data-id="element-284">
                <Link to="/houses" className="hover:text-gold transition-colors" data-id="element-285">
                  Premium Houses
                </Link>
              </li>
              <li data-id="element-286">
                <Link to="/land" className="hover:text-gold transition-colors" data-id="element-287">
                  Land & Plots
                </Link>
              </li>
              <li data-id="element-288">
                <Link to="/houses" className="hover:text-gold transition-colors" data-id="element-289">
                  Featured Estates
                </Link>
              </li>
              <li data-id="element-290">
                <Link to="/#book" className="hover:text-gold transition-colors" data-id="element-291">
                  Book Inspection
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-292">
            <h4 className="font-semibold text-ink mb-6" data-id="element-293">Company</h4>
            <ul className="space-y-4 text-sm text-ink/60" data-id="element-294">
              <li data-id="element-295">
                <Link to="/who-we-are" className="hover:text-gold transition-colors" data-id="element-296">
                  Who We Are
                </Link>
              </li>
              <li data-id="element-297">
                <Link to="/management-team" className="hover:text-gold transition-colors" data-id="element-298">
                  Management Team
                </Link>
              </li>
              <li data-id="element-299">
                <Link to="/board-of-directors" className="hover:text-gold transition-colors" data-id="element-300">
                  Board of Directors
                </Link>
              </li>
              <li data-id="element-301">
                <Link to="/certifications" className="hover:text-gold transition-colors" data-id="element-302">
                  Certifications
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-303">
            <h4 className="font-semibold text-ink mb-6" data-id="element-304">Media & Support</h4>
            <ul className="space-y-4 text-sm text-ink/60" data-id="element-305">
              <li data-id="element-306">
                <Link to="/blog" className="hover:text-gold transition-colors" data-id="element-307">
                  Zylus Blog
                </Link>
              </li>
              <li data-id="element-308">
                <Link to="/testimonials" className="hover:text-gold transition-colors" data-id="element-309">
                  Testimonials
                </Link>
              </li>
              <li data-id="element-310">
                <Link to="/contact" className="hover:text-gold transition-colors" data-id="element-311">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-gold/20 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-ink/50" data-id="element-312">
          <p data-id="element-313">
            © {new Date().getFullYear()} Zylus Homes & Property. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-314">
            <a href="#" className="hover:text-ink transition-colors" data-id="element-315">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-ink transition-colors" data-id="element-316">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}